import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetEquipmentStatus } from '../../store/Lookup/lookupSlice';
import { useTranslation } from 'react-i18next';

const useLookupEquipmentStatus = () => {
  const dispatch = useDispatch();

  const { i18n } = useTranslation();

  useEffect(() => {
    if (EquipmentStatus?.length === 0) {
      dispatch(GetEquipmentStatus());
    }
  }, []);

  const { EquipmentStatus, loading, error } = useSelector(state => state.Lookup);

  const EquipmentStatusOptions = EquipmentStatus?.map((item, idx) =>
    item.list?.map(list => ({
      label: i18n.language === 'en' ? list.meaning : list.meaning2,
      value: list.lookupCode
    }))
  )[0];

  return { EquipmentStatus, EquipmentStatusOptions, loading, error };
};

export default useLookupEquipmentStatus;
